<template>
  <div class="d-flex justify-content-center">
    <div class="variable-wrap">
      <div class="card-content card-variable">
        <div class="title-with-add">
          <p class="card-title">Variables</p>
          <p
            class="btn-add"
            @click="openModalAdd()"
          >
            <i class="fa fa-plus" /> Add
          </p>
        </div>

        <!-- List Variable -->
        <div class="list-variable">
          <div
            v-for="(data, index) in dummyData"
            :key="`variable-${index}`"
            class="variable">
            <div class="left-section">
              <img
                src="@/assets/app-manager/icon/variable-icon.svg"
                alt="variable-icon"
                class="variable-icon"
              >
              <div class="variable-name">{{ data.name }}</div>
              <div class="variable-value ellipsis">{{ data.value }}</div>
            </div>
            <div class="right-section">
              <i
                class="fa fa-pencil-square-o edit-variable"
                @click="openModalAdd(data)"
              />
              <i class="fa fa-trash delete-variable" />
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Add & Edit -->
      <modal-variable
        v-if="isOpenModalAdd"
        :id="idModalAdd"
        :data-variable="dataModalAdd"
        @close-modal="toggleModalAdd(false)"
      />
    </div>
  </div>
</template>

<script>
// Mixins
import jMixModalAdd from '@/mixins/app-manager/jMixModalAdd';
// Componenets
import modalVariable from '@/views/application-manager/detail/app-tabs/partials/modal/modalVariable';

export default {
  components: {
    modalVariable,
  },

  mixins: [
    jMixModalAdd,
  ],

  data() {
    return {
      idModalAdd: 'modalAdd',
      dummyData: [
        {
          name: 'Variable 1',
          type: 'text',
          value: 'https://gateway.jojonomic.com',
        },
        {
          name: 'Variable 2',
          type: 'text',
          value: 'https://gateway.jojonomic.com',
        },
        {
          name: 'Variable 3',
          type: 'text',
          value: 'https://gateway.jojonomic.com',
        },
        {
          name: 'Variable 4',
          type: 'text',
          value: 'https://gateway.jojonomic.com',
        },
        {
          name: 'Variable 5',
          type: 'text',
          value: 'https://gateway.jojonomic.com',
        },
        {
          name: 'Variable 6',
          type: 'text',
          value: 'https://gateway.jojonomic.com',
        },
        {
          name: 'Variable 7',
          type: 'text',
          value: 'https://gateway.jojonomic.com',
        },
        {
          name: 'Variable 8',
          type: 'text',
          value: 'https://gateway.jojonomic.com',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/jVariablesTab.vue